import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'

import {
  destinationCountQueryParams,
  durationQueryParams,
  filterKeys,
} from '../configuration/filtering'
import { getBrand, getSortOrderConfiguration } from '../redux/reducers/configuration'
import { getFiltersForQueryParams } from '../redux/reducers/filters'
import { getCurrentPage } from '../redux/reducers/page'
import { getSortOrder } from '../redux/reducers/sorting'

const countFilters = [filterKeys.destinationCount, filterKeys.duration]

export function useURLSearchParams() {
  const brand = useSelector(getBrand)
  const filters = useSelector(getFiltersForQueryParams)
  const page = useSelector(getCurrentPage)
  const sortOrder = useSelector(getSortOrder)
  const defaultSortOrder = useSelector(getSortOrderConfiguration);

  useEffect(() => {
    if (brand) {
      const urlSearchParams = new URLSearchParams();

      if (filters) {
        const parsedFilters = JSON.parse(filters)
        _.forEach(parsedFilters, (filter, filterKey) => {
          if (_.includes(countFilters, filterKey)) {
            if (filterKey === filterKeys.destinationCount) {
              urlSearchParams.set(destinationCountQueryParams[0], parseInt(filter.min, 10))
              urlSearchParams.set(destinationCountQueryParams[1], parseInt(filter.max, 10))
            } else if (filterKey === filterKeys.duration) {
              urlSearchParams.set(durationQueryParams[0], parseInt(filter.min, 10))
              urlSearchParams.set(durationQueryParams[1], parseInt(filter.max, 10))
            }
          } else {
            urlSearchParams.set(filterKey, encodeURIComponent(_.join(filter, '|')))
          }
        })
      }

      if (sortOrder && sortOrder !== defaultSortOrder) {
        urlSearchParams.set('sortBy', sortOrder);
      }

      if (page) {
        urlSearchParams.set('page', page)
      }

      const searchParamString = urlSearchParams.toString();
      const newURLPath = `${_.get(window, 'location.orgin', '')}${_.get(window, 'location.pathname', '')}${searchParamString ? `?${searchParamString}` : ''}`;
      window.history.replaceState(null, null, newURLPath);
    }
  }, [brand, defaultSortOrder, page, sortOrder, filters])
}
